import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/bhojanshala/schemes";

export const Route = createFileRoute("/admin/_bhojanshala/bhojan-schemes")({
  component: Page,
});
